
import { defineComponent, ref, reactive, inject, computed } from "vue";
import { ElMessage } from "element-plus";

const mockData = [
    { id: 1, car_code: "粤S55555", brand: "丰田卡罗拉 1.6L", vin: "LVZA53P97JC265756", company: "平安保险", commercial_amount: 6666, ci_amount: 666, total_amount: 6666, issuer: "张三", issue_date: "2026-06-25", expire_date: "2026-07-25", provider: "老王", defeat_reason: "", remark: "备注1" },
    { id: 2, car_code: "粤S55555", brand: "丰田卡罗拉 1.6L", vin: "LVZA53P97JC265756", company: "平安保险", commercial_amount: 6666, ci_amount: 666, total_amount: 6666, issuer: "张三", issue_date: "2026-06-26", expire_date: "2026-07-25", provider: "老王", defeat_reason: "", remark: "备注1" },
    { id: 3, car_code: "粤S55555", brand: "丰田卡罗拉 1.6L", vin: "LVZA53P97JC265756", company: "平安保险", commercial_amount: 6666, ci_amount: 666, total_amount: 6666, issuer: "张三", issue_date: "2026-06-27", expire_date: "2026-07-25", provider: "老王", defeat_reason: "", remark: "备注1" },
    { id: 4, car_code: "粤S55555", brand: "丰田卡罗拉 1.6L", vin: "LVZA53P97JC265756", company: "平安保险", commercial_amount: 6666, ci_amount: 666, total_amount: 6666, issuer: "张三", issue_date: "2026-06-28", expire_date: "2026-07-25", provider: "老王", defeat_reason: "", remark: "备注1" },
    { id: 5, car_code: "粤S55555", brand: "丰田卡罗拉 1.6L", vin: "LVZA53P97JC265756", company: "平安保险", commercial_amount: 6666, ci_amount: 666, total_amount: 6666, issuer: "张三", issue_date: "2026-06-29", expire_date: "2026-07-25", provider: "老王", defeat_reason: "", remark: "备注1" },
];

export default defineComponent({
    name: "Guarantee",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["保单列表"]);

        const headClass = inject("headClass");
        const pageSize = ref(10);
        const currentPage = ref(1);
        const dateRange = ref([] as any);
        const searchParams = reactive({ company: "", search: "" });

        const pagedData = computed(() => {
            const start = (currentPage.value - 1) * pageSize.value;
            return mockData.slice(start, start + pageSize.value);
        });

        const handleSizeChange = (size: number) => {
            pageSize.value = size;
            currentPage.value = 1;
        };

        const handleCurrentChange = (page: number) => {
            currentPage.value = page;
        };

        // 审核
        const auditForm = reactive({ dialog_show: false, car_code: "", reason: "", row: null as any });
        const auditPass = (row: any) => {
            console.log("审核通过:", row);
            ElMessage.success("审核通过");
        };
        const auditReject = (row: any) => {
            auditForm.dialog_show = true;
            auditForm.car_code = row.car_code;
            auditForm.reason = "";
            auditForm.row = row;
        };
        const auditSubmit = () => {
            if (!auditForm.reason) { ElMessage.warning("请填写不通过原因"); return; }
            console.log("审核不通过:", auditForm.row, "原因:", auditForm.reason);
            auditForm.dialog_show = false;
        };

        return {
            headClass,
            pageSize,
            currentPage,
            dateRange,
            searchParams,
            mockData,
            pagedData,
            handleSizeChange,
            handleCurrentChange,
            auditForm,
            auditPass,
            auditReject,
            auditSubmit,
        };
    },
});
